import { render, staticRenderFns } from "./CentralizedOpsReviewedApplication.vue?vue&type=template&id=5f78bf36"
import script from "./CentralizedOpsReviewedApplication.vue?vue&type=script&lang=js"
export * from "./CentralizedOpsReviewedApplication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports